import React from 'react';
import PDFViewer from 'pdf-viewer-reactjs';

const link =
  'https://fh.filgolf.com/files/ele/C9_Audited_Financial_Statements_as_of_31_December_2023.pdf';

export default function C6() {
  return (
    <>
      <h5 className="is-size-5 mb-4">
        <strong>
          C.7. Audited Financial Statements as of 31 December 2021
        </strong>
      </h5>
      <a className="button  is-link" href={link} download>
        DOWNLOAD
      </a>
      <PDFViewer
        document={{
          url: link
        }}
        rotationAngle={0}
        css="customViewer"
      />
    </>
  );
}
